import {
  PriceListItemCalculateType,
  type PriceListResource,
} from "@exonn/js-sdk";

export const getCalculateValueAdornment = ({
  priceList,
  calculate_type,
}: {
  priceList: PriceListResource;
  calculate_type: PriceListItemCalculateType;
}) => {
  if (calculate_type === PriceListItemCalculateType.Absolute) {
    return priceList.currency?.iso;
  }
  if (calculate_type === PriceListItemCalculateType.Fixed) {
    return priceList.currency?.iso;
  }
  if (calculate_type === PriceListItemCalculateType.Percent) {
    return "%";
  }
  return null;
};
